import React, { useRef, useState, useEffect } from "react";
import { FormikProvider, useFormik } from "formik";
import { Link } from "react-router-dom";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";
import { POST_GetTopDepartmentsData } from "../../../helpers/url_helper";

import * as echarts from "echarts";

const TopDepartments = () => {
  const [isLoading, setIsLoading] = useState(false);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [topDepartmentsList, setTopDepartmentsList] = useState([]);

  const formik = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      ActiveInwardType: 1,
      TopDepartmentsList: [],
      DepartmentNames: [],
      TestingCounts: [],
      PeriodType: 1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: {
      ActiveInwardType,
      TopDepartmentsList,
      DepartmentNames,
      TestingCounts,
      PeriodType,
    },
  } = formik;

  useEffect(() => {
    getTopDepartmentDetails(1);
  }, []);

  const getTopDepartmentDetails = async (typeid) => {
    formik.setFieldValue("PeriodType", typeid);
    // getData(typeid);
    setIsLoading(true);

    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      PeriodType: typeid,
    };

    await post(POST_GetTopDepartmentsData, payload)
      .then((response) => {
        formik.setFieldValue("TopDepartmentsList", response?.List);
        bindChartData(response?.List);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const bindChartData = (list) => {
    let departmentNameArray = [],
      testingCountArray = [];

    Promise.all(
      list?.map((x) => {
        departmentNameArray.push(x.DepartmentName);
        testingCountArray.push(x.TestingCount);
      })
    );

    formik.setFieldValue("DepartmentNames", departmentNameArray);
    formik.setFieldValue("TestingCounts", testingCountArray);
  };

  const chartRef = useRef();

  useEffect(() => {
    const myChart = echarts.init(chartRef.current);

    const options = {
      tooltip: {
        trigger: "item",
        formatter: "{b} <br/>Testing Count : {c}",
      },
      // legend: {
      //   top: "5%",
      //   left: "center",
      // },
      series: [
        {
          name: "",
          type: "pie",
          radius: ["40%", "70%"],
          center: ["50%", "50%"],
          // avoidLabelOverlap: false,
          padAngle: 1,
          itemStyle: {
            borderRadius: 5,
          },
          label: {
            show: true,
            // position: "center",
            color: "inherit",
          },
          // emphasis: {
          //   label: {
          //     show: true,
          //     fontSize: 17,
          //     fontWeight: "bold",
          //   },
          // },
          labelLine: {
            show: true,
          },
          data: TopDepartmentsList.map((item) => ({
            name: item.DepartmentName,
            value: item.TestingCount,
          })),
        },
      ],
      grid: {
        left: 20,
        top: 20,
        right: "5%",
        bottom: "5%",
      },
    };

    myChart.setOption(options);

    // Clean up the chart instance
    return () => {
      myChart.dispose();
    };
  }, [TopDepartmentsList]);

  return (
    <>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <div className="card mb-2" style={{ height: "calc(100% - 10px)" }}>
          <div className="card-body p-0">
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0 ps-2">Top Department</h4>
                <FormikProvider value={formik}>
                  <form onSubmit={formik.handleSubmit}>
                    <div className="d-flex align-items-center">
                      <Link
                        title="Current Year"
                        className={`btn ${
                          PeriodType == 1
                            ? "btn-primary"
                            : "btn-outline-primary"
                        } btn-sm`}
                        onClick={(e) => {
                          getTopDepartmentDetails(1);
                        }}
                      >
                        CY
                      </Link>
                      &nbsp;
                      <Link
                        title="Current Month"
                        className={`btn ${
                          PeriodType == 2
                            ? "btn-primary"
                            : "btn-outline-primary"
                        } btn-sm`}
                        onClick={(e) => {
                          getTopDepartmentDetails(2);
                        }}
                      >
                        CM
                      </Link>
                      &nbsp;
                      <Link
                        title="Previous Month"
                        className={`btn ${
                          PeriodType == 3
                            ? "btn-primary"
                            : "btn-outline-primary"
                        } btn-sm`}
                        onClick={(e) => {
                          getTopDepartmentDetails(3);
                        }}
                      >
                        PM
                      </Link>
                    </div>
                  </form>
                </FormikProvider>
              </div>

              <div>
                <div
                  ref={chartRef}
                  style={{ width: "100%", height: "400px" }}
                ></div>
              </div>
              {/* <div className="p-2 pt-0 pb-0">
                  <div
                    id="projects-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="projects-tbl"
                      className="table ItemsCheckboxSec dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "10%" }}>Sr No</th>
                          <th style={{ width: "70%" }}>Department Name</th>
                          <th style={{ width: "20%", textAlign: "left" }}>
                            Test Count
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {TopDepartmentsList?.length > 0 ? (
                          TopDepartmentsList?.map((item, indx) => (
                            <tr key={indx}>
                              <td>{indx + 1}</td>
                              <td>{item.DepartmentName}</td>
                              <td style={{ textAlign: "left" }}>
                                {item.TestingCount}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={3} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div> */}
            </div>
          </div>
        </div>
      </Spin>
    </>
  );
};

export default TopDepartments;
